export default __webpack_public_path__ + "static/media/naghsherostam.02452d94.jpg";